'use strict';

import raven from 'raven';
import Config from 'config';

class CollectionController {
  /* @ngInject */
  constructor(
    CollectionsService,
    ClientsService,
    EmployeesService,
    ReceiptsService,
    ProceduresService,
    SpendingsService,
    $scope,
    $window,
    $mdDialog,
    LoopBackAuth,
    $location,
    $mdToast,
    $state
  ) {
    this.collectionItems = $scope.$parent.$resolve.collectionItems || [];
    this.user = $scope.$parent.$resolve.user;

    Object.assign(this, {
      CollectionsService,
      ClientsService,
      EmployeesService,
      ReceiptsService,
      ProceduresService,
      SpendingsService,
      $scope,
      $window,
      $mdDialog,
      LoopBackAuth,
      $location,
      $mdToast,
      $state
    });

    this.btnEnabled = true;
    this.model = $scope.$parent.$resolve.collection;

    this.showReceiptSpin = {};
  }

  $onInit() {
    this.receipts = [];
    this.cashboxTransfers = [];
    this.spendings = [];

    if (!this.model) {
      this.model = this.CollectionsService.create({
        date: new Date()
      });
    } else {
      this.employee = this.model.employee;
      this.receipts = this.model.receipts;
      this.cashboxTransfers = this.model.cashboxTransfers;
      this.spendings = this.model.spendings;
      this.operativeSpendings = this.model.operativeSpendings;
      delete this.model.receipts;
      delete this.model.employee;
      delete this.model.spendings;
      delete this.model.operativeSpendings;

      this.updateTotalSpendings();
      this.updateTotalReceipts();
    }
    this.updateStateLabel();
  }

  removeReceipt(ev, receipt) {
    var confirm = this.$mdDialog
      .confirm()
      .title('Confirmacion')
      .textContent('Desea realmente eliminar el recibo?')
      .ariaLabel('Lucky day')
      .targetEvent(ev)
      .ok('Si, eliminar')
      .cancel('Cancelar');

    this.$mdDialog
      .show(confirm)
      .then(() => {
        this.showReceiptSpin[receipt.id] = true;
        return this.CollectionsService.removeReceipt({
          collectionId: this.model.id,
          receiptId: receipt.id
        });
      })
      .then(result => {
        Object.assign(this.model, result.collection);
        this.showReceiptSpin[receipt.id] = false;
        this.simpleSuccess('Recibo eliminado correctamente');
        let index = this.receipts.findIndex(r => r.id == receipt.id);
        if (index > -1) {
          this.receipts.splice(index, 1);
        }
        this.updateTotalReceipts();
      }, this.simpleError);
  }

  queryEmployeeSearch() {
    return this.EmployeesService.find({
      filter: {
        where: {
          name: {
            regexp: `^${this.searchEmployeeText}/i`
          }
        }
      }
    });
  }

  selectedEmployeeChange(employee) {
    if (employee) {
      this.model.employee = employee;
      this.employee = employee;
      this.save();
    }
  }

  save() {
    let firstTimeSave = false;
    if (!this.model.id) {
      firstTimeSave = true;
    }
    return this.model.$save().then(() => {
      if (firstTimeSave) {
        this.$state.go('edit' + this.Service.Model.modelName, {
          id: this.model.id
        });
      }
    });
  }

  pdf() {
    let url = `${Config.publicUrl}/api/Collections/pdf?id=${this.model.id}&\
access_token=${this.LoopBackAuth.accessTokenId}`;
    this.$window.open(url);
  }

  simpleSuccess(msg, hideDelay) {
    if (!msg) msg = `Operación completada con éxito`;
    this.$mdToast.show(
      this.$mdToast.simple({
        toastClass: 'success',
        hideDelay: hideDelay || 2500,
        textContent: msg
      })
    );
  }

  simpleError(msg, hideDelay) {
    if (!msg) msg = `Ocurrió un error`;
    this.$mdToast.show(
      this.$mdToast.simple({
        toastClass: 'error',
        hideDelay: hideDelay || 2500,
        textContent: msg
      })
    );
  }

  updateTotalSpendings() {
    this.totalSpendings = this.spendings.reduce((sum, s) => {
      if (!s.voucherId) {
        return sum + s.amount;
      } else {
        return sum;
      }
    }, 0);
    this.totalOperativeSpendings = this.operativeSpendings.reduce((sum, s) => {
      if (!s.voucherId) {
        return sum + s.amount;
      } else {
        return sum;
      }
    }, 0);
    this.model.totalAmount =
      this.totalReceipts +
      this.totalCashboxTransfers -
      this.totalSpendings -
      this.totalOperativeSpendings;
  }

  updateTotalReceipts() {
    this.totalReceipts = this.receipts.reduce((sum, value) => {
      return sum + value.amount;
    }, 0);
    this.totalCashboxTransfers = this.cashboxTransfers.reduce((sum, value) => {
      return sum + value.amount;
    }, 0);
    this.model.totalAmount =
      this.totalReceipts +
      this.totalCashboxTransfers -
      this.totalSpendings -
      this.totalOperativeSpendings;
  }

  removeSpending(ev, spending) {
    var confirm = this.$mdDialog
      .confirm()
      .title('Confirmacion')
      .textContent(`Desea realmente quitar el gasto de esta rendición?`)
      .ariaLabel('Lucky day')
      .targetEvent(ev)
      .ok('Si, quitar')
      .cancel('Cancelar');

    this.$mdDialog
      .show(confirm)
      .then(() => {
        return this.CollectionsService.removeSpending({
          collectionId: this.model.id,
          spendingId: spending.id
        });
      })
      .then(result => {
        Object.assign(this.model, result.collection);
        this.showSpendingSpin = false;
        this.simpleSuccess('Gasto eliminado correctamente');
        let index = this.spendings.findIndex(r => r.id == spending.id);
        if (index > -1) {
          this.spendings.splice(index, 1);
        }
        this.updateTotalSpendings();
      }, this.simpleError);
  }

  removeOperativeSpending(ev, oSpending) {
    var confirm = this.$mdDialog
      .confirm()
      .title('Confirmacion')
      .textContent(`Desea realmente quitar el gasto de esta rendición?`)
      .ariaLabel('Lucky day')
      .targetEvent(ev)
      .ok('Si, quitar')
      .cancel('Cancelar');

    this.$mdDialog
      .show(confirm)
      .then(() => {
        return this.CollectionsService.removeOperativeSpending({
          collectionId: this.model.id,
          oSpendingId: oSpending.id
        });
      })
      .then(result => {
        Object.assign(this.model, result.collection);
        this.showSpendingSpin = false;
        this.simpleSuccess('Gasto eliminado correctamente');
        let index = this.operativeSpendings.findIndex(
          s => s.id == oSpending.id
        );
        if (index > -1) {
          this.operativeSpendings.splice(index, 1);
        }
        this.updateTotalSpendings();
      }, this.simpleError);
  }

  recreate() {
    this.showSpin = true;
    this.CollectionsService.getDraft({
      employeeId: this.model.employeeId,
      reset: true
    }).then(
      result => {
        this.showSpin = false;
        this.$state.go(
          'editCollection',
          {
            id: result.collection.id
          },
          {
            reload: true
          }
        );
      },
      err => {
        raven.captureException(err);
        this.simpleError('Ha ocurrido un error');
      }
    );
  }

  getObjectData(r) {
    let id = Object.keys(r)[0];
    let amount = r[id];
    return {
      id: id,
      amount: amount
    };
  }

  getOperativeSpendingLabel(oSpending) {
    let labelItems = [];
    if (oSpending.holder) {
      labelItems.push(`${oSpending.holder.lastName} ${oSpending.holder.name}`);
    }
    if (oSpending.vehicle) {
      labelItems.push(`${oSpending.vehicle.plate}`);
    }
    if (oSpending.quote) {
      labelItems.push(`OT #${oSpending.quote.id}`);
    }
    return labelItems.join(' - ');
  }

  approve() {
    if (this.model.state != 'sent') {
      return this.simpleError('La rendicion no fue enviada a tesoreria');
    }
    this.showApproveSpin = true;
    this.CollectionsService.approve({
      id: this.model.id
    }).then(
      // eslint-disable-next-line no-unused-vars
      result => {
        this.model.state = 'approved';
        this.showApproveSpin = false;
        this.updateStateLabel();
        this.checkForExtraCollections();
      },
      err => {
        this.showApproveSpin = false;
        raven.captureException(err);
        this.simpleError('Ha ocurrido un error');
      }
    );
  }

  disapprove(ev) {
    if (this.model.state != 'approved') {
      return this.simpleError('La rendicion no fue aprobada');
    }
    var confirm = this.$mdDialog
      .confirm()
      .title('Confirmacion')
      .textContent(
        `Desea realmente volver la rendición al estado \
borrador?`
      )
      .ariaLabel('Lucky day')
      .targetEvent(ev)
      .ok('Si')
      .cancel('Cancelar');

    this.$mdDialog
      .show(confirm)
      .then(() => {
        return this.CollectionsService.disapprove({
          id: this.model.id
        });
      })
      // eslint-disable-next-line no-unused-vars
      .then(result => {
        this.model.state = 'draft';
        this.updateStateLabel();
      });
  }

  sendToTreasury() {
    if (this.model.state != 'draft') {
      return this.simpleError('La rendicion no es borrador');
    }

    var confirm = this.$mdDialog
      .confirm()
      .title('Confirmacion')
      .textContent('Desea enviar la rendición a Tesorería?')
      .ok('Si, enviar')
      .cancel('Cancelar');

    this.$mdDialog.show(confirm).then(() => {
      this.showSendToTreasurySpin = true;
      this.CollectionsService.sendToTreasury({
        id: this.model.id
      }).then(
        // eslint-disable-next-line no-unused-vars
        result => {
          this.model.state = 'sent';
          this.showSendToTreasurySpin = false;
          this.updateStateLabel();
        },
        err => {
          this.showSendToTreasurySpin = false;
          raven.captureException(err);
          this.simpleError('Ha ocurrido un error');
        }
      );
    });
  }

  reject() {
    if (this.model.state != 'sent') {
      return this.simpleError('La rendicion no fue enviada a tesoreria');
    }

    var confirm = this.$mdDialog
      .prompt()
      .title('Rechazo de rendición')
      .textContent('Ingrese el motivo')
      .placeholder('Motivo de rechazo')
      .ariaLabel('Motivo de rechazo')
      .required(true)
      .ok('Rechazar rendición')
      .cancel('Cancelar');

    this.$mdDialog.show(confirm).then(result => {
      this.showRejectSpin = true;
      this.CollectionsService.reject({
        id: this.model.id,
        reason: result
      }).then(
        // eslint-disable-next-line no-unused-vars
        result => {
          this.showRejectSpin = false;
          this.$state.go(
            'editCollection',
            {
              id: this.model.id
            },
            {
              reload: true
            }
          );
        },
        err => {
          this.showRejectSpin = false;
          raven.captureException(err);
          this.simpleError('Ha ocurrido un error');
        }
      );
    });
  }

  removeCashboxTransfer(ev, cashboxTransfer) {
    return this.CollectionsService.removeCashboxTransfer({
      collectionId: this.model.id,
      cashboxTransferId: cashboxTransfer.id
    }).then(result => {
      Object.assign(this.model, result.collection);
      this.simpleSuccess('Transferencia de caja eliminada correctamente');
      let index = this.cashboxTransfers.findIndex(
        c => c.id == cashboxTransfer.id
      );
      if (index > -1) {
        this.cashboxTransfers.splice(index, 1);
      }
      this.updateTotalReceipts();
    }, this.simpleError);
  }

  checkForExtraCollections() {
    return this.CollectionsService.find({
      where: {
        employeeId: this.model.employeeId,
        state: 'sent'
      },
      order: 'createdAt DESC'
    }).then(collections => {
      if (collections.length) {
        return this.$mdDialog.show(
          this.$mdDialog
            .alert()
            .clickOutsideToClose(true)
            .title('ATENCION: rendiciones pendientes')
            .textContent(
              `Este gestor tiene otras rendiciones \
pendientes de ser aprobadas`
            )
            .ok('Aceptar')
        );
      }
    });
  }

  updateStateLabel() {
    const labels = {
      draft: 'BORRADOR',
      sent: 'ENVIADA',
      approved: 'APROBADA'
    };

    this.stateLabel = labels[this.model.state];
  }
}

export default CollectionController;
